import { render } from "./InitialUwRecentLoansCard.vue?vue&type=template&id=6659395f&scoped=true"
import script from "./InitialUwRecentLoansCard.vue?vue&type=script&lang=js"
export * from "./InitialUwRecentLoansCard.vue?vue&type=script&lang=js"

import "./InitialUwRecentLoansCard.vue?vue&type=style&index=0&id=6659395f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6659395f"]])

export default __exports__